import React from 'react';

const Bouton = (props) => {
    const btnClasses = `btn ${props.className}`;
    return(
        <>
            <button className={btnClasses} onClick={props.clic}>{props.children}</button>
        </>
    );
}

export default Bouton;